module.exports = __webpack_public_path__ + "img/00044.54171fe0.webp";